import Purchase from "../../slices/purchase/Purchase"
import Sessions from "../../slices/sessions/Sessions"
import Ticket from "../../slices/ticket/Ticket"
import Recharge from "../../slices/recharge/recharge/Recharge"
import PurchaseHistory from "../../slices/recharge/purchase_history/PurchaseHistory"

// Single-page customer modules (Purchase, Sessions, Ticket, Recharge, Plan Purchase History)
const customerReducer = {
    purchase: Purchase,
    sessions: Sessions,
    ticket: Ticket,
    recharge: Recharge,
    purchaseHistory: PurchaseHistory,
};

export default customerReducer;
